const getElementPositionRelativeToDocument = element =>
    element ? element.getBoundingClientRect().top + document.documentElement.scrollTop : null;

const getElement = name => document.getElementsByName(name)[0] || null;

export const scrollToInvalid = errors => {
    if (errors) {
        const positions = Object.keys(errors)
            .map(name => {
                const elt = getElement(name);
                const pos = getElementPositionRelativeToDocument(elt);
                return pos ? { name, pos, elt } : null;
            })
            .filter(p => !!p);

        const invalidInput = positions.reduce((acc, cur) => {
            return acc.pos < cur.pos ? acc : cur;
        }, positions[0]);

        if (invalidInput && invalidInput.elt) {
            window.scrollTo(0, invalidInput.pos - 50);
            invalidInput.elt.focus();
        }
    }
};



// WEBPACK FOOTER //
// ./src/components/form/utils.js